<template>
    <div class="price-tabs-container">
        <div class="price-tab" v-for="period in periods" :key="period.key">
            <span class="tab-label">{{ period.label }}</span>
            <span
                class="tab-value"
                :class="getChangeClass(period.change)"
            >
                {{ formatChange(period.change) }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PriceChangeTabs',

    props: {
        mint: {
            type: String,
            required: true
        },
        initialData: {
            type: Object,
            default: null
        }
    },

    data() {
        return {
            // Mock data - will be replaced with real data
            periods: [
                { key: '5m', label: '5m', change: -0.06 },
                { key: '1h', label: '1h', change: -0.86 },
                { key: '6h', label: '6h', change: -1.04 },
                { key: '24h', label: '24h', change: 1.51 }
            ]
        };
    },

    methods: {
        getChangeClass(change) {
            if (change > 0) return 'change-positive';
            if (change < 0) return 'change-negative';
            return 'change-neutral';
        },

        formatChange(change) {
            const prefix = change >= 0 ? '+' : '';
            return prefix + change.toFixed(2) + '%';
        }
    },

    mounted() {
        // TODO: Fetch real price change data
        // this.fetchPriceChanges();
    }
};
</script>

<style scoped>
/* Inline price change display - no bubbles */
.price-tabs-container {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0.25rem 0;
}

.price-tab {
    display: flex;
    align-items: baseline;
    gap: 0.35rem;
}

.tab-label {
    font-size: 0.7rem;
    font-weight: 600;
    color: var(--compass-text-secondary, #7d8590);
    text-transform: uppercase;
    letter-spacing: 0.03em;
}

.tab-value {
    font-family: 'JetBrains Mono', 'SF Mono', monospace;
    font-size: 0.8rem;
    font-weight: 600;
}

.change-positive {
    color: var(--compass-success, #22c55e);
}

.change-negative {
    color: var(--compass-danger, #ef4444);
}

.change-neutral {
    color: var(--compass-text-secondary, #7d8590);
}

/* Responsive */
@media (max-width: 768px) {
    .price-tabs-container {
        gap: 0.5rem;
        flex-wrap: wrap;
    }

    .tab-label {
        font-size: 0.6rem;
    }

    .tab-value {
        font-size: 0.7rem;
    }
}
</style>
